import { API } from './resources'

export default {
  getLanguagesForProject: (projectID) => {
    return API.get(`/auditorium/${projectID}/languages`)
  },
  getLanguagesForVideo: (projectID) => {
    return API.get(`/videos/${projectID}/languages`)
  }
}
